export const getAuthHeader = () => {
  const token = localStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const withAuthHeaders = (headers = {}) => ({
  ...headers,
  ...getAuthHeader(),
});
